import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';


export default class ForLoopNode extends BaseNode {
    constructor() {
        super();
        this.name = 'For-Next Loop';
        this.id = 'node_forloop';
        this.icon = 'GrIteration';
        this.linkedFeature = 'general';

        this.inputs = [
            {
                name: 'Run',
                portId: 'for_loop',
                params: [
                    {
                        name: 'start',
                        dataType: TibboDataType.BYTE,
                        default: '0',
                        description: 'The value to start at (inclusive)',
                    },
                    {
                        name: 'end',
                        dataType: TibboDataType.BYTE,
                        description: 'The value to stop at (inclusive)',
                        default: '5',
                    },
                ],
            },
        ];

        this.outputs = [
            {
                name: 'Iteration',
                portId: 'for_loop_iterate',
                params: [
                    {
                        name: 'current_iteration',
                        dataType: TibboDataType.BYTE,
                    },
                ],
            },
            {
                name: 'Done',
                portId: 'for_loop_done',
                params: [],
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return `##### For-Next Loop
Executes blocks for a defined number of times.`;
    }
}
